import { displayNameIn, useStore } from '../../store/store';

export function TypingIndicator({ channelId }: { channelId: string }) {
  const typing = useStore((s) => s.typing[channelId]);
  const relationships = useStore((s) => s.relationships);
  const spaceId = useStore((s) => s.channels[channelId]?.spaceId ?? null);
  const ids = Object.keys(typing ?? {}).filter((id) => relationships[id]?.type !== 'blocked');
  const state = useStore.getState();
  const names = ids.map((id) => displayNameIn(state, id, spaceId));
  let text = '';
  if (names.length === 1) text = `${names[0]} is typing`;
  else if (names.length === 2) text = `${names[0]} and ${names[1]} are typing`;
  else if (names.length === 3) text = `${names[0]}, ${names[1]} and ${names[2]} are typing`;
  else if (names.length > 3) text = 'Several people are typing';
  return (
    <div className="flex h-6 items-center gap-2 px-4 text-xs text-muted" aria-live="polite">
      {text && (
        <>
          <span className="flex gap-0.5" aria-hidden>
            <span className="typing-dot size-1.5 rounded-full bg-muted" />
            <span className="typing-dot size-1.5 rounded-full bg-muted [animation-delay:150ms]" />
            <span className="typing-dot size-1.5 rounded-full bg-muted [animation-delay:300ms]" />
          </span>
          <span className="truncate">
            <span className="font-semibold text-fg">{text}</span>
            {'…'}
          </span>
        </>
      )}
    </div>
  );
}
